import fleetTypeIconBicycle from '../global/img/vehicle-type-bycicle.svg';
import fleetTypeIconCar from '../global/img/vehicle-type-car.svg';
import fleetTypeIconPedestrian from '../global/img/vehicle-type-pedestrian.svg';
import fleetTypeIconScooter from '../global/img/vehicle-type-scooter.svg';
import fleetTypeIconTruck from '../global/img/vehicle-type-truck.svg';
import fleetTypeIconBus from '../global/img/vehicle-type-bus.svg';
import fleetTypeIconPrivateBus from '../global/img/vehicle-type-privatebus.svg';
import fleetTypeIconTaxi from '../global/img/vehicle-type-taxi.svg';

import { getSafeValue } from './security';

const fleetTypeIcons = {
  bicycle: fleetTypeIconBicycle,
  car: fleetTypeIconCar,
  pedestrian: fleetTypeIconPedestrian,
  scooter: fleetTypeIconScooter,
  truck: fleetTypeIconTruck,
  bus: fleetTypeIconBus,
  privateBus: fleetTypeIconPrivateBus,
  taxi: fleetTypeIconTaxi,
};

export const getFleetTypeIcon = (type) => getSafeValue(fleetTypeIcons, type);

// Fleet profile names and vehicle type IDs are embedded directly into the VRP JSON as
// identifiers (e.g. fleet.profiles[].name, fleet.types[].id, fleet.types[].profile), which
// must match "^[a-zA-Z0-9_-]+$" — spaces are not allowed. Replace any whitespace with
// underscores as the user types so the value stays valid.
export const sanitizeFleetIdentifier = (value) => (value || '').replace(/\s+/g, '_');

export const getVehicleProfile = (vehicleId, vehicles, vehicleProfiles) => {
  // TODO: Get vehicle profile from Solution file when the property has been added

  if (!vehicles || !vehicleProfiles) return { type: 'car' };
  const vehicle = vehicles.find((v) => v.id === vehicleId);
  if (!vehicle) return undefined;
  return vehicleProfiles.find((profile) => profile.name === vehicle.profile);
};
